const ScrollbarPlugin = {
    install(app, options = {}) {
        // Объединяем стандартные настройки с пользовательскими
        const pluginOptions = {
            className: 'has-scrollbar',
            cssVarName: '--scrollbar-width',
            ...options,
        };

        const docEl = document.documentElement;
        const body = document.body;

        // Расчет ширины скроллбара
        const calculateScrollbarWidth = () => {
            return window.innerWidth - docEl.offsetWidth;
        };

        // Проверка на наличие блюра
        const isBlurDivActive = (className) => {
            return document.querySelector('.' + className);
        };

        // Переключение div'а с блюром
        const toggleBlurDiv = (show, className) => {
            const existingBlur = document.querySelector('.' + className);
            if (show) {
                if (!existingBlur) {
                    const blur = document.createElement('div');
                    blur.classList.add(className);
                    document.body.appendChild(blur);
                }
            } else if (existingBlur) {
                existingBlur.remove();
            }
        };

        // Функция применения настроек
        const applySettings = (param, newClassName = 'blur-body') => {
            const hasScrollbarClass = body.classList.contains(
                pluginOptions.className
            );
            if (!isBlurDivActive(newClassName) && !hasScrollbarClass) {
                // Устанавливаем CSS-переменную с шириной скроллбара
                docEl.style.setProperty(
                    pluginOptions.cssVarName,
                    `${calculateScrollbarWidth()}px`
                );
            }
            // Переключаем div с блюром и класс у body
            toggleBlurDiv(param, newClassName);
            body.classList.toggle(pluginOptions.className, param);

            if (!body.classList.contains(pluginOptions.className)) {
                docEl.style.setProperty(pluginOptions.cssVarName, `0px`);
            }
        };

        const scrollbarAPI = { applySettings };
        // Добавляем в глобальные свойства Vue
        app.config.globalProperties.$scrollbar = scrollbarAPI;
        // Доступ через provide/inject API
        app.provide('scrollbarPlugin', scrollbarAPI);
    },
};
export default ScrollbarPlugin;
